import React, { Component } from "react";
import { Button, Container, Tabs } from "@amzn/awsui-components-react";
import TrailblazerGraph from "./components/TrailblazerGraph";
import TrailblazerTable from "./components/TrailblazerTable";
import TrailblazerStack from "./components/TrailblazerStack";

/**
 * This component handles displaying the Trailblazer visualization view.
 * There are two tabs: the graph view and the list view.
 */
export default class TrailblazerVisual extends Component {
    static GRAPH_VIEW_TAB_ID = "graphViewTab";
    static TABLE_VIEW_TAB_ID = "tableViewTab";
    static LIST_VIEW_TAB_ID = "listViewTab";

    constructor(props) {
        super(props);

        this.handleTabChange = this.handleTabChange.bind(this);
    }

    state = {
        activeTabId: TrailblazerVisual.GRAPH_VIEW_TAB_ID
    };

    /**
     * This function specifies the tabs of the page.
     * There are currently two tabs: graph view and list view.
     */
    updateTabs = () => {
        const graphViewTab = {
            label: "Graph View",
            id: TrailblazerVisual.GRAPH_VIEW_TAB_ID,
            content: <TrailblazerGraph route={this.props.selectedRoute}/>
        };

        const tableViewTab = {
            label: "Table View",
            id: TrailblazerVisual.TABLE_VIEW_TAB_ID,
            content: <TrailblazerTable route={this.props.selectedRoute}/>
        };

        const listViewTab = {
            label: "List View",
            id: TrailblazerVisual.LIST_VIEW_TAB_ID,
            content: <TrailblazerStack route={this.props.selectedRoute}/>
        };

        return [
            graphViewTab, tableViewTab, listViewTab
        ];
    };

    /**
     * This function handles changing the active tab on the Tabs component.
     */
    handleTabChange = async (evt) => {
        const { activeTabId: activeId } = evt.detail;
        this.setState({
            activeTabId: activeId
        });
    };

    render() {
        const { selectedRoute, onBackClick } = this.props;
        if (!selectedRoute) {
            return (
                <Container>
                    <div>No selected route</div>
                </Container>
            );
        }

        return (
            <div>
                <Button
                    iconName="arrow-left"
                    onClick={onBackClick}
                    variant="link"
                >
                    Back to routes
                </Button>

                <Tabs
                    tabs={this.updateTabs()}
                    activeTabId={this.state.activeTabId}
                    variant="container"
                    onChange={this.handleTabChange}
                />
            </div>
        );
    }
}